(function(){
  var countEl=document.getElementById("cartCount"),cartBtn=document.getElementById("cartBtn");
  var toast=document.getElementById("toast"),toastText=document.getElementById("toastText"),tt;
  function say(m){if(!toast)return;toastText.textContent=m;toast.classList.add("show");clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove("show")},2600)}
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
  document.addEventListener("submit",function(e){
    var f=e.target;if(!f.classList||!f.classList.contains("add-form"))return;
    e.preventDefault();
    var btn=f.querySelector("button[type=submit]");if(btn)btn.disabled=true;
    fetch(root+"cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){return fetch(root+"cart.js").then(function(r){return r.json()})})
      .then(function(c){if(countEl)countEl.textContent=c.item_count;if(cartBtn){cartBtn.classList.remove("bump");void cartBtn.offsetWidth;cartBtn.classList.add("bump")}say((btn&&btn.getAttribute("data-name")||"Produkten")+" ligger i varukorgen")})
      .catch(function(err){say((err&&err.description)||"Det gick inte att lägga till. Försök igen.")})
      .finally(function(){if(btn)btn.disabled=false});
  });
})();
